import { render, staticRenderFns } from "./ShipmentsHistoryView.vue?vue&type=template&id=22621250"
import script from "./ShipmentsHistoryView.vue?vue&type=script&lang=js"
export * from "./ShipmentsHistoryView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports